import { MenuOption } from "@lexical/react/LexicalTypeaheadMenuPlugin";

export class ConfigurableVariableOption extends MenuOption {
    constructor(
        public text: string,
        public value: string,
        public dataType?: string,
        public displayText?: string,
        public nodeId?: string
    ) {
        super(text);
    }
}
